import { render, staticRenderFns } from "./DraggableTreeviewNode.vue?vue&type=template&id=b09e5f0e&"
import script from "./DraggableTreeviewNode.vue?vue&type=script&lang=js&"
export * from "./DraggableTreeviewNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports